// Have List SMS alert monthly caps — regional model.
//
// Twilio toll-free SMS to international destinations costs 3–10x US rates, so the cap
// depends on the user's region: US/Canada gets the higher cap, everyone else gets the
// lower one. Region is determined by the user's shipping address country (`shippingCountry`,
// an ISO 2-letter code): `US` or `CA` is domestic, anything else — including null/missing —
// is international. Phone number and the `phoneCountryCode` field are deliberately NOT used
// for region (product decision; phone country code is also a known greedy-regex bug).
//
// These constants and `getMonthlyAlertLimit` are defensive fallbacks for the UI only —
// the authoritative value is the backend-provided `alertsMonthlyLimit` field on the
// `/settings/have-list-defaults` response. They are kept byte-identical to the backend's
// own `src/constants/haveListAlerts.ts` (same file path, constant names, helper name and
// signature) so the two repos can't drift.
export const FREE_TIER_MONTHLY_ALERT_LIMIT_US = 15;
export const FREE_TIER_MONTHLY_ALERT_LIMIT_INTL = 5;
export const ELITE_TIER_MONTHLY_ALERT_LIMIT_US = 300;
export const ELITE_TIER_MONTHLY_ALERT_LIMIT_INTL = 50;

// Deprecated — alias to the US values. Kept one release for cross-repo parity and
// trivial reversibility; a cleanup ticket removes them once the backend drops them.
export const FREE_TIER_MONTHLY_ALERT_LIMIT = FREE_TIER_MONTHLY_ALERT_LIMIT_US;
export const ELITE_TIER_MONTHLY_ALERT_LIMIT = ELITE_TIER_MONTHLY_ALERT_LIMIT_US;

// Resolves the monthly alert cap for a user. Region is decided by the shipping country:
// `US` or `CA` is US/Canada, anything else (including null/undefined) is international.
// null/undefined errs toward international — the lower cap is the cost-safe default.
export function getMonthlyAlertLimit(isElite: boolean, shippingCountry: string | null): number {
  const isDomestic = shippingCountry === 'US' || shippingCountry === 'CA';
  if (isElite) {
    return isDomestic ? ELITE_TIER_MONTHLY_ALERT_LIMIT_US : ELITE_TIER_MONTHLY_ALERT_LIMIT_INTL;
  }
  return isDomestic ? FREE_TIER_MONTHLY_ALERT_LIMIT_US : FREE_TIER_MONTHLY_ALERT_LIMIT_INTL;
}
